// extracted by mini-css-extract-plugin
module.exports = {"AssetList":"AssetList_AssetList__Yb-8K","TableWrapper":"AssetList_TableWrapper__fnz6Z"};